import { jsx as t } from "react/jsx-runtime";
import { c as s, l as c, m as a } from "../../vendor-Blw3V4C-.js";
import { forwardRef as d } from "react";
import { stupidInvertClasses as p } from "../../utils/index.js";
import { ChildFilter as m } from "../../utils/ChildFilter/index.js";
import '../../assets/index17.css';const n = "_tooltip_ktkg9_1", f = {
  tooltip: n
}, h = d(
  ({ placement: o = "top", __inverted: i, children: e }, r) => {
    const l = s(f.tooltip, i ? p() : void 0);
    return /* @__PURE__ */ t(c, { ref: r, placement: o, className: l, "data-tooltip": !0, children: /* @__PURE__ */ t(m, { invalidChildren: ["a", "button", "iconbutton", "link"], children: e }) });
  }
), k = (o) => a({ ...o, delay: o.delay === "immediate" ? 0 : 300, closeDelay: 0 });
export {
  h as Tooltip,
  k as TooltipTrigger
};
//# sourceMappingURL=index.js.map
